import Form from 'components/Form';

import { Grid, Typography } from '@mui/material';

import RowContainer from '../components/RowContainer';
import RowContent from '../components/RowContent';

import { Ti18nId } from 'hooks/useI18n';
import { IFormRegister, IFormValues, IFormWatch } from 'routes/Main/type';

import { Stack } from '@mui/system';

interface Props extends IFormValues, IFormWatch, IFormRegister {
  disabled?: boolean;
  onRequired: (id: Ti18nId) => void;
  onSuccess: (message: string) => void;
}

const checks_cardio_1 = [
  {
    label: 'SB',
    key: 'assessment_cardio.checked1',
  },
  {
    label: 'NSR',
    key: 'assessment_cardio.checked2',
  },
  {
    label: 'ST',
    key: 'assessment_cardio.checked3',
  },
  {
    label: '心房顫動',
    key: 'assessment_cardio.checked4',
  },
  {
    label: '心房撲動',
    key: 'assessment_cardio.checked5',
  },
  {
    label: '心房起搏',
    key: 'assessment_cardio.checked6',
  },
  {
    label: '心室起搏',
    key: 'assessment_cardio.checked7',
  },
  {
    label: '房性早搏',
    key: 'assessment_cardio.checked8',
  },
];

const checks_cardio_2 = [
  {
    label: '室性早搏',
    key: 'assessment_cardio.checked9',
  },
  {
    label: '植入型心臟自動除顫器',
    key: 'assessment_cardio.checked10',
  },
  {
    label: '心雜音',
    key: 'assessment_cardio.checked11',
  },
  {
    label: '阻滯',
    key: 'assessment_cardio.checked12',
  },
];

const checks_cardio_edema1 = [
  { label: '无', key: 'assessment_cardio_edema.checked1' },
  { label: '全身', key: 'assessment_cardio_edema.checked2' },
  { label: '微量', key: 'assessment_cardio_edema.checked3' },
  { label: '1+', key: 'assessment_cardio_edema.checked4' },
  { label: '2+', key: 'assessment_cardio_edema.checked5' },
  { label: '3+', key: 'assessment_cardio_edema.checked6' },
];

const checks_cardio_edema2 = [
  { label: '凹陷性', key: 'assessment_cardio_edema.checked7' },
  { label: '非凹陷性', key: 'assessment_cardio_edema.checked8' },
];

const checks_cardio_edema3 = [
  { label: '右', key: 'assessment_cardio_edema.checked9' },
  { label: '左', key: 'assessment_cardio_edema.checked10' },
  { label: '双侧', key: 'assessment_cardio_edema.checked11' },
];

const checks_cardio_edema4 = [
  { label: '手臂', key: 'assessment_cardio_edema.checked12' },
  { label: '腿部', key: 'assessment_cardio_edema.checked13' },
];

const checks_cardio_pulses1 = [
  { label: '足背动脉', key: 'assessment_cardio_pulse.checked1' },
  { label: '桡动脉', key: 'assessment_cardio_pulse.checked2' },
];

const checks_cardio_pulses2 = [
  { label: '多普勒', key: 'assessment_cardio_pulse.checked3' },
  { label: '+1', key: 'assessment_cardio_pulse.checked4' },
  { label: '+2', key: 'assessment_cardio_pulse.checked5' },
];

const checks_vte_1 = [
  { label: '间歇性气压装置', key: 'assessment_vte.checked1' },
  { label: '足部泵', key: 'assessment_vte.checked2' },
  { label: '肝素', key: 'assessment_vte.checked3' },
  { label: '羧基化肝素', key: 'assessment_vte.checked4' },
  { label: '香豆素', key: 'assessment_vte.checked5' },
];

const checks_vte_2 = [
  { label: '利伐沙班', key: 'assessment_vte.checked6' },
  { label: '阿哌沙班', key: 'assessment_vte.checked7' },
  { label: '无需', key: 'assessment_vte.checked8' },
  { label: '需要醫囑', key: 'assessment_vte.checked9' },
];

const checks_vte_diet_1 = [
  { label: '常规饮食', key: 'assessment_gastro_diet.checked1' },
  { label: '清液饮食', key: 'assessment_gastro_diet.checked2' },
  { label: '全流质饮食', key: 'assessment_gastro_diet.checked3' },
  { label: '美國心臟協會飲食', key: 'assessment_gastro_diet.checked4' },
  { label: '美國糖尿病協會飲食', key: 'assessment_gastro_diet.checked5' },
];

const checks_vte_diet_2 = [
  { label: '吞咽困难 I 级', key: 'assessment_gastro_diet.checked6' },
  { label: '吞咽困难 II 级', key: 'assessment_gastro_diet.checked7' },
  { label: '吞咽困难 III 级', key: 'assessment_gastro_diet.checked8' },
  { label: '软食', key: 'assessment_gastro_diet.checked9' },
  { label: '肾脏饮食', key: 'assessment_gastro_diet.checked10' },
  { label: '禁食', key: 'assessment_gastro_diet.checked11' },
];

const checks_vte_symptom = [
  { label: '低活动', key: 'assessment_gastro_symptom.checked1' },
  { label: '正常活动', key: 'assessment_gastro_symptom.checked2' },
  { label: '过度活动', key: 'assessment_gastro_symptom.checked3' },
  { label: '恶心', key: 'assessment_gastro_symptom.checked4' },
  { label: '呕吐', key: 'assessment_gastro_symptom.checked5' },
  { label: '腹泻', key: 'assessment_gastro_symptom.checked6' },
];

const checks_vte_tube = [
  { label: '造口', key: 'assessment_gastro_tube.checked1' },
  { label: '胃管（LWS）', key: 'assessment_gastro_tube.checked2' },
  { label: '胃管（重力）', key: 'assessment_gastro_tube.checked3' },
];

const Assessment3 = (props: Props) => {
  const { disabled, register, getValues, setValue } = props;

  return (
    <>
      <RowContainer
        xs={12}
        sx={{ margin: '0px 0px 5px 0px', marginLeft: '-25px' }}
      >
        <RowContent title="生命体征趋势" titleRatio={1.2} childrenRatio={10.8}>
          <Stack direction="row" spacing={1}>
            <Grid item xs={1.4}>
              <Typography
                variant="caption"
                fontWeight={400}
                lineHeight="38px"
                sx={{ whiteSpace: 'nowrap' }}
              >
                心率
              </Typography>
            </Grid>

            <Grid item xs={2.9}>
              <Stack direction="row">
                <Form.MuiTextField
                  required={false}
                  disabled={disabled}
                  placeholder="进入"
                  {...register('assessment_vs_hr')}
                />
              </Stack>
            </Grid>
          </Stack>
        </RowContent>
        <RowContent title="" titleRatio={1.2} childrenRatio={10.8}>
          <Stack direction="row" spacing={1}>
            <Grid item xs={1.4}>
              <Typography
                variant="caption"
                fontWeight={400}
                lineHeight="38px"
                sx={{ whiteSpace: 'nowrap' }}
              >
                体温
              </Typography>
            </Grid>

            <Grid item xs={2.9}>
              <Stack direction="row">
                <Form.MuiTextField
                  required={false}
                  disabled={disabled}
                  placeholder="进入"
                  {...register('assessment_vs_temp')}
                />
              </Stack>
            </Grid>
          </Stack>
        </RowContent>
        <RowContent title="" titleRatio={1.2} childrenRatio={10.8}>
          <Stack direction="row" spacing={1}>
            <Grid item xs={1.4}>
              <Typography
                variant="caption"
                fontWeight={400}
                lineHeight="38px"
                sx={{ whiteSpace: 'nowrap' }}
              >
                血压
              </Typography>
            </Grid>

            <Grid item xs={2.9}>
              <Stack direction="row">
                <Form.MuiTextField
                  required={false}
                  disabled={disabled}
                  placeholder="进入"
                  {...register('assessment_vs_bp')}
                />
              </Stack>
            </Grid>
          </Stack>
        </RowContent>
        <RowContent title="" titleRatio={1.2} childrenRatio={10.8}>
          <Stack direction="row" spacing={1}>
            <Grid item xs={1.4}>
              <Typography
                variant="caption"
                fontWeight={400}
                lineHeight="38px"
                sx={{ whiteSpace: 'nowrap' }}
              >
                呼吸频率
              </Typography>
            </Grid>

            <Grid item xs={2.9}>
              <Stack direction="row">
                <Form.MuiTextField
                  required={false}
                  disabled={disabled}
                  placeholder="进入"
                  {...register('assessment_vs_rr')}
                />
              </Stack>
            </Grid>
          </Stack>
        </RowContent>
        <RowContent title="" titleRatio={1.2} childrenRatio={10.8}>
          <Stack direction="row" spacing={1}>
            <Grid item xs={1.4}>
              <Typography
                variant="caption"
                fontWeight={400}
                lineHeight="38px"
                sx={{ whiteSpace: 'nowrap' }}
              >
                O<sub>2</sub>
              </Typography>
            </Grid>

            <Grid item xs={2.9}>
              <Stack direction="row">
                <Form.MuiTextField
                  required={false}
                  disabled={disabled}
                  placeholder="进入"
                  {...register('assessment_vs_o2')}
                />
              </Stack>
            </Grid>
          </Stack>
        </RowContent>
        <RowContent title="心血管" titleRatio={1.2} childrenRatio={10.8}>
          <Stack direction="row" spacing={1}>
            {checks_cardio_1.map((v, i) => {
              return (
                <Grid item xs={1.4}>
                  <Stack direction="row">
                    <Form.MuiCheckbox
                      label={v.label}
                      disabled={disabled}
                      defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                      onChange={(_, checked) => {
                        setValue(v.key, checked);
                      }}
                    />
                  </Stack>
                </Grid>
              );
            })}
          </Stack>
        </RowContent>
        <RowContent title="" titleRatio={1.2} childrenRatio={10.8}>
          <Stack direction="row" spacing={1}>
            {checks_cardio_2.map((v, i) => {
              return (
                <Grid item xs={i === 6 ? 0.5 : 1.4}>
                  <Stack direction="row">
                    <Form.MuiCheckbox
                      label={v.label}
                      disabled={disabled}
                      defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                      onChange={(_, checked) => {
                        setValue(v.key, checked);
                      }}
                    />
                  </Stack>
                </Grid>
              );
            })}
          </Stack>
        </RowContent>
        <RowContent title="" titleRatio={1.2} childrenRatio={10.8}>
          <Stack direction="row" spacing={1}>
            <Grid item xs={1.4}>
              <Typography
                variant="caption"
                fontWeight={400}
                lineHeight="38px"
                sx={{ whiteSpace: 'nowrap' }}
              >
                水腫
              </Typography>
            </Grid>

            {checks_cardio_edema1.map((v, i) => {
              return (
                <Grid item xs={1.4}>
                  <Stack direction="row">
                    <Form.MuiCheckbox
                      label={v.label}
                      disabled={disabled}
                      defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                      onChange={(_, checked) => {
                        setValue(v.key, checked);
                      }}
                    />
                  </Stack>
                </Grid>
              );
            })}
          </Stack>
        </RowContent>
        <RowContent title="" titleRatio={1.2} childrenRatio={10.8}>
          <Stack direction="row" spacing={1}>
            <Grid item xs={1.4}></Grid>

            {checks_cardio_edema2.map((v, i) => {
              return (
                <Grid item xs={1.4}>
                  <Stack direction="row">
                    <Form.MuiCheckbox
                      label={v.label}
                      disabled={disabled}
                      defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                      onChange={(_, checked) => {
                        setValue(v.key, checked);
                      }}
                    />
                  </Stack>
                </Grid>
              );
            })}
          </Stack>
        </RowContent>
        <RowContent title="" titleRatio={1.2} childrenRatio={10.8}>
          <Stack direction="row" spacing={1}>
            <Grid item xs={1.4}></Grid>

            {checks_cardio_edema3.map((v, i) => {
              return (
                <Grid item xs={1.4}>
                  <Stack direction="row">
                    <Form.MuiCheckbox
                      label={v.label}
                      disabled={disabled}
                      defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                      onChange={(_, checked) => {
                        setValue(v.key, checked);
                      }}
                    />
                  </Stack>
                </Grid>
              );
            })}
          </Stack>
        </RowContent>
        <RowContent title="" titleRatio={1.2} childrenRatio={10.8}>
          <Stack direction="row" spacing={1}>
            <Grid item xs={1.4}></Grid>

            {checks_cardio_edema4.map((v, i) => {
              return (
                <Grid item xs={1.4}>
                  <Stack direction="row">
                    <Form.MuiCheckbox
                      label={v.label}
                      disabled={disabled}
                      defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                      onChange={(_, checked) => {
                        setValue(v.key, checked);
                      }}
                    />
                  </Stack>
                </Grid>
              );
            })}
          </Stack>
        </RowContent>
        <RowContent title="" titleRatio={1.2} childrenRatio={10.8}>
          <Stack direction="row" spacing={1}>
            <Grid item xs={1.4}>
              <Typography
                variant="caption"
                fontWeight={400}
                lineHeight="38px"
                sx={{ whiteSpace: 'nowrap' }}
              >
                脈搏
              </Typography>
            </Grid>

            {checks_cardio_pulses1.map((v, i) => {
              return (
                <Grid item xs={1.4}>
                  <Stack direction="row">
                    <Form.MuiCheckbox
                      label={v.label}
                      disabled={disabled}
                      defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                      onChange={(_, checked) => {
                        setValue(v.key, checked);
                      }}
                    />
                  </Stack>
                </Grid>
              );
            })}
          </Stack>
        </RowContent>
        <RowContent title="" titleRatio={1.2} childrenRatio={10.8}>
          <Stack direction="row" spacing={1}>
            <Grid item xs={1.4}></Grid>

            {checks_cardio_pulses2.map((v, i) => {
              return (
                <Grid item xs={1.4}>
                  <Stack direction="row">
                    <Form.MuiCheckbox
                      label={v.label}
                      disabled={disabled}
                      defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                      onChange={(_, checked) => {
                        setValue(v.key, checked);
                      }}
                    />
                  </Stack>
                </Grid>
              );
            })}
          </Stack>
        </RowContent>
        <RowContent
          title="靜脈血栓栓塞預防"
          titleRatio={1.2}
          childrenRatio={10.8}
        >
          <Stack direction="row" spacing={1}>
            {checks_vte_1.map((v, i) => {
              return (
                <Grid item xs={1.4}>
                  <Stack direction="row">
                    <Form.MuiCheckbox
                      label={v.label}
                      disabled={disabled}
                      defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                      onChange={(_, checked) => {
                        setValue(v.key, checked);
                      }}
                    />
                  </Stack>
                </Grid>
              );
            })}
          </Stack>
        </RowContent>
        <RowContent title="" titleRatio={1.2} childrenRatio={10.8}>
          <Stack direction="row" spacing={1}>
            {checks_vte_2.map((v, i) => {
              return (
                <Grid item xs={1.4}>
                  <Stack direction="row">
                    <Form.MuiCheckbox
                      label={v.label}
                      disabled={disabled}
                      defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                      onChange={(_, checked) => {
                        setValue(v.key, checked);
                      }}
                    />
                  </Stack>
                </Grid>
              );
            })}
          </Stack>
        </RowContent>
        <RowContent title="胃腸道" titleRatio={1.2} childrenRatio={10.8}>
          <Stack direction="row" spacing={1}>
            <Grid item xs={1.4}>
              <Typography
                variant="caption"
                fontWeight={400}
                lineHeight="38px"
                sx={{ whiteSpace: 'nowrap' }}
              >
                飲食
              </Typography>
            </Grid>
            {checks_vte_diet_1.map((v, i) => {
              return (
                <Grid item xs={1.4}>
                  <Stack direction="row">
                    <Form.MuiCheckbox
                      label={v.label}
                      disabled={disabled}
                      defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                      onChange={(_, checked) => {
                        setValue(v.key, checked);
                      }}
                    />
                  </Stack>
                </Grid>
              );
            })}
          </Stack>
        </RowContent>
        <RowContent title="" titleRatio={1.2} childrenRatio={10.8}>
          <Stack direction="row" spacing={1}>
            <Grid item xs={1.4}></Grid>
            {checks_vte_diet_2.map((v, i) => {
              return (
                <Grid item xs={1.4}>
                  <Stack direction="row">
                    <Form.MuiCheckbox
                      label={v.label}
                      disabled={disabled}
                      defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                      onChange={(_, checked) => {
                        setValue(v.key, checked);
                      }}
                    />
                  </Stack>
                </Grid>
              );
            })}
          </Stack>
        </RowContent>
        <RowContent title="" titleRatio={1.2} childrenRatio={10.8}>
          <Stack direction="row" spacing={1}>
            <Grid item xs={1.4}>
              <Typography
                variant="caption"
                fontWeight={400}
                lineHeight="38px"
                sx={{ whiteSpace: 'nowrap' }}
              >
                症狀
              </Typography>
            </Grid>
            {checks_vte_symptom.map((v, i) => {
              return (
                <Grid item xs={1.4}>
                  <Stack direction="row">
                    <Form.MuiCheckbox
                      label={v.label}
                      disabled={disabled}
                      defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                      onChange={(_, checked) => {
                        setValue(v.key, checked);
                      }}
                    />
                  </Stack>
                </Grid>
              );
            })}
          </Stack>
        </RowContent>
        <RowContent title="" titleRatio={1.2} childrenRatio={10.8}>
          <Stack direction="row" spacing={1}>
            <Grid item xs={1.4}>
              <Typography
                variant="caption"
                fontWeight={400}
                lineHeight="38px"
                sx={{ whiteSpace: 'nowrap' }}
              >
                管道
              </Typography>
            </Grid>
            {checks_vte_tube.map((v, i) => {
              return (
                <Grid item xs={1.4}>
                  <Stack direction="row">
                    <Form.MuiCheckbox
                      label={v.label}
                      disabled={disabled}
                      defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                      onChange={(_, checked) => {
                        setValue(v.key, checked);
                      }}
                    />
                  </Stack>
                </Grid>
              );
            })}
          </Stack>
        </RowContent>
      </RowContainer>
    </>
  );
};

export default Assessment3;
